// @flow

import type { P2PStatsState } from './reducers'

type P2PStatsStore = { p2pStats: P2PStatsState }

export const getP2PStats = (state: P2PStatsStore): P2PStatsState => state.p2pStats
